"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  DiamondGive: ['diamond-give', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M4.087 5.242L19.913 5.242', 'M8.561.742h6.878a.755.755,0,0,1,.531.22l3.724,3.724a.751.751,0,0,1-.026,1.086l-7.163,6.512a.751.751,0,0,1-1.01,0L4.332,5.772a.751.751,0,0,1-.026-1.086L8.03.962A.755.755,0,0,1,8.561.742Z', 'M8.269 0.802L11.916 12.474', 'M15.731 0.802L12.084 12.474', 'M3.75,23.242,1.736,20.725A4.5,4.5,0,0,1,.75,17.914V12.742a1.5,1.5,0,0,1,1.5-1.5h0a1.5,1.5,0,0,1,1.5,1.5v3.75', 'M8.25,23.106v-3a4.5,4.5,0,0,0-.757-2.5L6.351,15.9a1.4,1.4,0,0,0-1.977-.444h0a1.4,1.4,0,0,0-.476,1.79l1.352,2.25', 'M20.25,23.242l2.014-2.517a4.5,4.5,0,0,0,.986-2.811V12.742a1.5,1.5,0,0,0-1.5-1.5h0a1.5,1.5,0,0,0-1.5,1.5v3.75', 'M15.75,23.106v-3a4.5,4.5,0,0,1,.757-2.5L17.649,15.9a1.4,1.4,0,0,1,1.977-.444h0a1.4,1.4,0,0,1,.476,1.79l-1.352,2.25']],
  TreasureChestOpen: ['treasure-chest-open', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21.334,12a2.968,2.968,0,0,0,.416-1.5,2.987,2.987,0,0,0-4.789-2.395,5.216,5.216,0,0,0-9.922,0A2.984,2.984,0,0,0,2.666,12Z', 'M20.25 2.25L23.25 2.25', 'M21.75 0.75L21.75 3.75', 'M0.75 4.5L3.75 4.5', 'M2.25 3L2.25 6', 'M.75,12h22.5a0,0,0,0,1,0,0V22.25a1,1,0,0,1-1,1H1.75a1,1,0,0,1-1-1V12a0,0,0,0,1,0,0Z', 'M5.25 15L5.25 23.25', 'M9.75 17.25L9.75 23.25', 'M14.25 17.25L14.25 23.25', 'M18.75 15L18.75 23.25', 'M0.75 15L8.325 15', 'M15.675 15L23.25 15', 'M15.75,14.25a3.75,3.75,0,0,1-7.5,0V12h7.5Z', 'M12,14.625a.375.375,0,1,1-.375.375A.375.375,0,0,1,12,14.625']],
  DiamondShine: ['diamond-shine', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12 23.242L18 17.242 18 6.742 12 0.742 6 6.742 6 17.242 12 23.242z', 'M12 0.742L12 23.242', 'M6 6.742L18 6.742', 'M6 17.242L18 17.242', 'M21 11.992L23.25 11.992', 'M20.25 3.742L21.75 2.242', 'M20.25 20.242L21.75 21.742', 'M3 11.992L0.75 11.992', 'M3.75 3.742L2.25 2.242', 'M3.75 20.242L2.25 21.742']],
  TreasureChest: ['treasure-chest', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.75,9.75h22.5a0,0,0,0,1,0,0v11a1,1,0,0,1-1,1H1.75a1,1,0,0,1-1-1v-11A0,0,0,0,1,.75,9.75Z', 'M2.75,2.25h18.5a2,2,0,0,1,2,2v5.5a0,0,0,0,1,0,0H.75a0,0,0,0,1,0,0V4.25A2,2,0,0,1,2.75,2.25Z', 'M5.25 12.75L5.25 21.75', 'M5.25 2.25L5.25 9.75', 'M9.75 15L9.75 21.75', 'M9.75 2.25L9.75 9.75', 'M14.25 15L14.25 21.75', 'M14.25 2.25L14.25 9.75', 'M18.75 12.75L18.75 21.75', 'M18.75 2.25L18.75 9.75', 'M0.75 12.75L8.325 12.75', 'M15.675 12.75L23.25 12.75', 'M15.75,12a3.75,3.75,0,0,1-7.5,0V9.75h7.5Z', 'M12,12.375a.375.375,0,1,1-.375.375A.375.375,0,0,1,12,12.375']],
  DiamondRing: ['diamond-ring', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M8.250 4.492 A3.750 3.750 0 1 0 15.750 4.492 A3.750 3.750 0 1 0 8.250 4.492 Z', 'M10.5,4.492a1.5,1.5,0,0,1,1.5-1.5', 'M14.63,7.17a8.251,8.251,0,1,1-5.253,0', 'M20.25 2.242L23.25 2.242', 'M21.75 0.742L21.75 3.742', 'M0.75 6.742L3.75 6.742', 'M2.25 5.242L2.25 8.242', 'M14.7,10.49a5.25,5.25,0,1,1-5.407,0']],
  GoldBars: ['gold-bars', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M8.945,13.5H3.481a1.533,1.533,0,0,0-1.516,1.217l-1.187,6A1.513,1.513,0,0,0,2.294,22.5h7.838a1.512,1.512,0,0,0,1.515-1.783l-1.187-6A1.532,1.532,0,0,0,8.945,13.5Z', 'M20.519,13.5H15.055a1.532,1.532,0,0,0-1.515,1.217l-1.187,6A1.512,1.512,0,0,0,13.868,22.5h7.838a1.513,1.513,0,0,0,1.516-1.783l-1.187-6A1.533,1.533,0,0,0,20.519,13.5Z', 'M14.945,4.5H9.481A1.533,1.533,0,0,0,7.965,5.717l-1.187,6A1.513,1.513,0,0,0,8.294,13.5h7.838a1.512,1.512,0,0,0,1.515-1.783l-1.187-6A1.532,1.532,0,0,0,14.945,4.5Z', 'M20.25 3L23.25 3', 'M21.75 1.5L21.75 4.5', 'M0.75 6.75L3.75 6.75', 'M2.25 5.25L2.25 8.25']],
  Diamond: ['diamond', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M19.237,3.225a1.5,1.5,0,0,0-1.2-.6h-12a1.5,1.5,0,0,0-1.2.6L1.5,7.676a1.5,1.5,0,0,0,.048,1.86l9.338,11.3a1.5,1.5,0,0,0,2.3,0l9.338-11.3a1.5,1.5,0,0,0,.048-1.86Z', 'M5.349 2.792L12.037 21.375', 'M18.724 2.792L12.037 21.375', 'M1.198 8.625L22.871 8.625', 'M7.537 8.625L12.037 2.625 16.537 8.625']],
  DiamondHold: ['diamond-hold', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M16.279,9.327a4.723,4.723,0,0,1,2.258,3.8,2.8,2.8,0,0,1-.7,1.97l-.994,1.136a1.884,1.884,0,0,1-2.75.091l-1.935-1.935a1.412,1.412,0,0,0-2,2l3.51,3.981a3.766,3.766,0,0,1,1.1,2.663v.208', 'M23.25,23.242V14.063a10.409,10.409,0,0,0-.414-2.555,7.688,7.688,0,0,0-4.459-4.957', 'M0.879 5.492L15.621 5.492', 'M3.47.75a.935.935,0,0,0-.831.5L.84,4.705a.771.771,0,0,0,.129.9l6.648,6.988a.886.886,0,0,0,1.266,0l6.648-6.988a.771.771,0,0,0,.129-.9L13.713,1.229A.937.937,0,0,0,12.9.75Z', 'M0.75 14.992L3.75 14.992', 'M2.25 13.492L2.25 16.492', 'M20.25 2.242L23.25 2.242', 'M21.75 0.742L21.75 3.742', 'M4.459 0.75L8.208 12.858', 'M12.041 0.75L8.292 12.858']]
};
exports["default"] = _default;